/*
 * fn: uniqueKeys
 *
 * De-dupes array keys
 *
 */
export const uniqueKeys = <T>(props: T[]): T[] => [...new Set(props)]
